/**
 * Context class for creator-elements communication
 */
export default class Context {

  constructor() {
    this.currentElement = {};
    this.dragularScope = {};
    this.clickOutsideEnabled = true;
  }

  setDragularScope(scope) {
    this.dragularScope = scope;
    scope.$on('$destroy', () => {
      this.clearCurrentElement();
    })
  };

  getDragularScope() {
    return this.dragularScope;
  };

  clearCurrentElement() {
    this.currentElement = {};
  };

  hasCurrentElement() {
    return this.currentElement ? Object.keys(this.currentElement).length !== 0 : false;
  };

  setCurrentElement(element) {
    this.currentElement = element;
  };

  getCurrentElement () {
    return this.currentElement;
  }

  setClickOutsideEnabled (status) {
    this.clickOutsideEnabled = (typeof status === 'undefined') ? true : status;
  }

  isClickOutsideEnabled() {
    return this.clickOutsideEnabled;
  }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/Context/Context.js